import React, { useRef, useState } from 'react';
import { motion, useInView } from 'framer-motion';
import heroVid from '../../assets/small4k.webm';
import CustomWhiteButton from '../../UI/Intro/customButton/customWhiteButton';
import './IntroFooter.css';
import EmailModal from '../../UI/EmailModal';
import { Snackbar, Alert } from '@mui/material';
import { useContactUsMutation } from '../../store/services/other/other';

const IntroFooter = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.5 });

  // Contact form and snackbar state
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [contactUs] = useContactUsMutation();

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);
  const handleSnackbarClose = () => setOpenSnackbar(false);
  const handleSendEmail = async (emailData) => {
    try {
      const response = await contactUs(emailData).unwrap();
      if (response.message === 'success') {
        setSnackbarMessage('Email sent successfully!');
        setSnackbarSeverity('success');
      }
    } catch (error) {
      setSnackbarMessage('An error occurred!');
      setSnackbarSeverity('error');
      handleClose();
    }
    setOpenSnackbar(true);
  };

  return (
    <div className="hero-bg-stack-footer">
      <motion.div
        ref={ref}
        className="hero-content-footer"
        initial={{ opacity: 0, y: 50 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8, ease: 'easeOut' }}
      >
        <p className='footer-text'>
          Ready to Explore the Cloud?<br />
          Start Your CloudLab Journey Today.
        </p>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '20px'
        }}>
          <CustomWhiteButton width="160px" firstText="Schedule a Demo" secondText="Schedule a Demo" handleClick={handleOpen} />
        </div>
      </motion.div>

      <video className="hero-bg-video-footer" src={heroVid} autoPlay loop muted playsInline />
      <div className="hero-bg-vignette-footer"></div>
      <EmailModal
        open={isModalOpen}
        handleClose={handleClose}
        handleSendEmail={handleSendEmail}
      />
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default IntroFooter;
